import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { MaintenanceComponent } from './maintenance.component';

@NgModule({
	imports: [CommonModule, ButtonModule],
	declarations: [MaintenanceComponent]
})
export class MaintenanceModule {}
